module.exports = __webpack_public_path__ + "static/media/bookmarks.eebcbf0d.svg";